var _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0826 0C15.7326 0 14.642 1.13402 14.642 2.53767V4.06027C9.07443 5.23395 4.87969 10.3569 4.87969 16.4949V17.9857C4.87969 21.7129 3.56025 25.3133 1.18069 28.1047L0.616311 28.7629C-0.0243403 29.5084 -0.176876 30.5789 0.21209 31.4909C0.601057 32.4029 1.47814 32.9897 2.43912 32.9897H17.0826L17.0826 32.0137L17.0826 30.4521L17.0826 29.1507L17.0826 27.8493V22.3836L17.0826 14.3151C17.0826 8.17708 17.0826 4.06027 17.0826 4.06027L17.0826 2.53767C17.0826 1.13402 17.0826 0 17.0826 0ZM17.0826 36.517L17.0826 34.3562V32.9247H12.2014C12.2014 34.2728 12.7124 35.5654 13.6276 36.517C14.5428 37.4687 15.786 38 17.0826 38L17.0826 36.517Z",
    fill: "#FAD65B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0825 0C18.4324 0 19.523 1.13402 19.523 2.53767V4.06027C25.0906 5.23395 29.2853 10.3569 29.2853 16.4949V17.9857C29.2853 21.7129 30.6048 25.3133 32.9843 28.1047L33.5487 28.7629C34.1894 29.5084 34.3419 30.5789 33.9529 31.4909C33.564 32.4029 32.6869 32.9897 31.7259 32.9897H17.0825L17.0825 32.0137L17.0825 30.4521L17.0825 29.1507L17.0825 27.8493V22.3836L17.0825 14.3151C17.0825 8.17708 17.0825 4.06027 17.0825 4.06027L17.0825 2.53767C17.0825 1.13402 17.0825 0 17.0825 0ZM17.0825 36.517L17.0825 34.3562V32.9247H21.9636C21.9636 34.2728 21.4526 35.5654 20.5374 36.517C19.6222 37.4687 18.379 38 17.0825 38L17.0825 36.517Z",
    fill: "#FCC739"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9631 32.9962L12.2017 32.9961L21.7888 34.2513C21.7888 34.2513 21.8772 33.8794 21.9283 33.6412C21.9793 33.4029 21.9631 32.9962 21.9631 32.9962Z",
    fill: "#DBAF38"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7982,
    cy: 7.49502,
    r: 3.83486,
    fill: "#EB1C24"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.4fccba58a4c7a60e8730be550b63518d.svg";
export { ForwardRef as ReactComponent };